export type UrlParams = Record<'plantCode' | 'page' | 'materialId' | '*', string | undefined>

export type SearchParamKey = 'start' | 'end' | 'materialType' | 'materialId' | 'month'
